<script>
import { Pie } from 'vue-chartjs'
import 'chartjs-plugin-labels'

export default {
  name: 'OtherDetailsCommunicationGraph',
  extends: Pie,
  props: {
    revenueSources: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      graphData: {
        labels: [],
        datasets: [{
          data: [],
          backgroundColor: [],
          borderWidth: 0,
        }],
      },
      graphOptions: {
        plugins: {
          labels: {
            outsidePadding: 0,
          },
        },
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      },
    }
  },

  watch: {
    revenueSources: {
      handler () { this.formatData() },
      deep: true,
    },
  },

  mounted () {
    this.formatData()
  },

  methods: {
    formatData () {
      this.revenueSources.map((source) => {
        const color = '#' + Object.values(source)[0].split('#')[1];
        const value = Object.values(source)[0].split('#')[0];
        this.graphData.labels.push(Object.keys(source)[0]);
        this.graphData.datasets[0].backgroundColor.push(color);
        this.graphData.datasets[0].data.push(value);
      })

      this.renderChart(this.graphData, this.graphOptions)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/partials/RevenueBreakdownGraph.vue